<template>
  <div class="wg-box-icon">
    <div class="themesflat-container">
      <div class="row">
        <div
          class="col-md-4"
          v-for="(deliveryIcon, index) in deliveryIcons"
          :key="index"
          @click="goToLink(deliveryIcon.link)"
        >
          <div class="box-icon" v-if="deliveryIcon">
            <div class="icon">
              <img
                class="w-full rounded-image"
                :src="getImageUrl(deliveryIcon.photo)"
                alt=""
              />
            </div>
            <div class="title">
              {{ deliveryIcon.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "DeliveryIconComponent",
  props: {
    msg: String,
  },
  data() {
    return {
      langStore,
      deliveryIcons: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchDeliveryIcons();
    },
  },

  mounted() {
    this.fetchDeliveryIcons();
  },

  methods: {
    async fetchDeliveryIcons() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/delivery-icon`,
          { params: { lang: this.langStore.lang } }
        );

        this.deliveryIcons = response.data;

        // WAIT FOR IMAGES TO LOAD
        this.waitForImages();
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },
    getImageUrl(photo) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/website/` + photo;
    },
    
    goToLink(link) {
      if (link) {
        window.open(link, "_blank"); // opens in new tab
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.rounded-image {
  border-radius: 50%;
  object-fit: cover;
}

.wg-box-icon::before {
  background-color: white !important;
}

.box-icon .icon::after {
  border: 1px solid #efbed4 !important;
}

.box-icon .title {
  color: #1f5f73 !important;
}

.box-icon {
  cursor: pointer;
}
</style>
